import { z } from "zod";
import { createAppError } from "../errors/application-error";
import type { DeliveryMethodType} from "./delivery-methods";
import { deliveryMethodType } from "./delivery-methods";
import type {
    DigitalDelivery} from "./digital/digital-delivery";
import {
    digitalDeliveryFactory,
    digitalDeliveryZodSchema,
} from "./digital/digital-delivery";
import type {
    HomeDelivery} from "./home-deliveries/home-delivery";
import {
    homeDeliveryFactory,
    homeDeliveryZodSchema,
} from "./home-deliveries/home-delivery";
import type {
    PickUpDelivery} from "./pick-ups/pick-up-delivery";
import {
    pickUpDeliveryFactory,
    pickUpDeliveryZodSchema,
} from "./pick-ups/pick-up-delivery";

type Delivery = PickUpDelivery | HomeDelivery | DigitalDelivery;
const deliveryZodSchema = z.union([
    pickUpDeliveryZodSchema,
    homeDeliveryZodSchema,
    digitalDeliveryZodSchema,
]);
//type Delivery = PickUpDelivery | HomeDelivery | DigitalDelivery;

const isPickUpDelivery = (delivery: Delivery): delivery is PickUpDelivery => {
    return delivery.deliveryMethodType === "PICK_UP";
};

const createDelivery = (deliveryMethod: DeliveryMethodType) => {
    switch (deliveryMethod) {
        case deliveryMethodType.PICK_UP:
            return pickUpDeliveryFactory;
        case deliveryMethodType.HOME_DELIVERY:
            return homeDeliveryFactory;
        case deliveryMethodType.DIGITAL:
            return digitalDeliveryFactory;
        case deliveryMethodType.TABLE_SERVICE:
        default:
            // eslint-disable-next-line @typescript-eslint/only-throw-error
            throw createAppError({
                errorCode: "INTERNAL_ERROR",
                message:
                    "Unhandled delivery method type (" + deliveryMethod + ")",
                publicMessage:
                    "Problem med leveranstypen, försök igen senare eller testa en annan leveranstyp",
            });
    }
};

export { createDelivery, deliveryZodSchema, isPickUpDelivery };
export type { Delivery };
